/* Nordic Floor — seriekalkulator (Fase B, T8).
   Regnestykket er identisk med assets/nf-kalkulator.js:
   brutto = areal × (1 + svinn), pakker = max(1, ceil(brutto / m² per pakke)),
   total = pakker × pakkepris. Svinn settes av mønsteret. */
(function () {
  'use strict';

  /* Identisk med lesAreal i assets/nf-kalkulator.js — se den for hvorfor
     feltet ikke lenger er type="number", og for hele fasitlista.
     Kort: «23,5» ble stille til 235 fordi nettleseren forkastet kommaet.
     Endres reglene her, må de endres der; test-desimal.js kjører begge
     mot samme liste, så avvik gir utslag. */
  function lesAreal(raa) {
    if (typeof raa !== 'string') return NaN;
    var s = raa.replace(/[\s   ]/g, '');
    if (s === '') return NaN;
    s = s.replace(/,/g, '.');
    if (s.slice(-1) === '.') s = s.slice(0, -1);
    if (s === '') return NaN;
    if (!/^\d*\.?\d+$/.test(s)) return NaN;
    return parseFloat(s);
  }

  /* Eksponert for regresjonsriggen. Ikke ment for annen bruk. */
  window.nfSerieLesAreal = lesAreal;

  function init(rot) {
    if (!rot || rot.dataset.nfInit) return;
    var el = function (n) { return rot.querySelector('[data-nf-serie="' + n + '"]'); };
    var dataEl = el('data');
    var velger = el('serie');
    var areal = el('areal');
    if (!dataEl || !velger || !areal) return;

    var serier;
    try { serier = JSON.parse(dataEl.textContent); } catch (e) { serier = []; }
    if (!serier.length) return;
    rot.dataset.nfInit = '1';

    serier.forEach(function (s, i) {
      var o = document.createElement('option');
      o.value = i;
      o.textContent = s.navn;
      velger.appendChild(o);
    });

    var ceil = function (v) { return Math.ceil(v - 1e-9); };
    var kr = function (v) {
      var d = v % 1 ? 2 : 0;
      return v.toLocaleString('nb-NO', { minimumFractionDigits: d, maximumFractionDigits: d }) + ' kr';
    };
    var komma = function (s) { return s.replace('.', ','); };

    function regn() {
      var s = serier[parseInt(velger.value, 10)] || serier[0];
      var m2pris = el('m2pris');
      if (m2pris) m2pris.textContent = s.prisM2 + ' kr/m²';

      var svinn = s.monster === 'fiskebein' || s.monster === 'chevron' ? 0.12 : 0.07;
      var raa = String(areal.value || '').trim();
      var a = lesAreal(raa);
      var res = el('resultat');
      if (!(a > 0)) {
        res.hidden = true;
        ansa(null);
        /* Et tall som ikke kan bli gyldig ved neste tast — 0 eller
           negativt — meldes med én gang; «abc» meldes ved blur under.
           Samme skille som i assets/nf-kalkulator.js. */
        visFeil(raa !== '' && !isNaN(a) && a <= 0 ? 'Arealet må være større enn 0 m².' : null);
        return;
      }
      visFeil(null);
      var lenke = el('lenke');
      if (lenke && s.url) {
        lenke.href = s.url;
        lenke.textContent = 'Se gulvene i ' + s.navn;
      }
      var brutto = a * (1 + svinn);
      var pakker = Math.max(1, ceil(brutto / s.m2pk));
      var kjopt = pakker * s.m2pk;
      var totalCents = pakker * s.pkCents;

      el('pakker').textContent = pakker + (pakker === 1 ? ' pakke' : ' pakker');
      /* Samme to linjer som produktsidens kalkulator — se
         assets/nf-kalkulator.js for hvorfor opprundingen ikke er svinn.
         `brutto` er arealet med svinn før opprunding, `kjopt` er det
         pakkene faktisk dekker. Begge var regnet ut fra før. */
      el('detalj').textContent =
        'Du trenger ' + komma(brutto.toFixed(2)) + ' m² inkl. ' +
        Math.round(svinn * 100) + ' % svinn\n' +
        pakker + (pakker === 1 ? ' pakke dekker ' : ' pakker dekker ') +
        komma(kjopt.toFixed(2)) + ' m²';
      el('total').innerHTML = 'Totalt <i>' + kr(totalCents / 100) + '</i>';

      /* Tvinger omstart av innglidningen når tallene endrer seg */
      res.hidden = false;
      res.style.animation = 'none';
      void res.offsetWidth;
      res.style.animation = '';
      /* Én linje til skjermleseren, i den rekkefoelgen kunden spoer. */
      /* Svinnet sies ogsaa her, med samme skille som detaljlinja: det er
         BRUTTOAREALET som er «inkl. svinn», pakkenes dekning er
         opprunding. Den foerste versjonen (27. september, formiddag) satte
         «inkl. N % svinn» paa dekningen — nettopp feilen detaljlinja ble
         skrevet om for aa unngaa; fanget i gjennomgangen samme dag. */
      ansa(s.navn + ': du trenger ' + komma(brutto.toFixed(2)) + ' m² inkl. ' + Math.round(svinn * 100) + ' % svinn, ' +
        pakker + (pakker === 1 ? ' pakke dekker ' : ' pakker dekker ') + komma(kjopt.toFixed(2)) +
        ' m², totalt ' + kr(totalCents / 100));
    }

    /* Sammenfatningen skrives med en liten pause etter siste tastetrykk,
       slik at «2», «23» og «230» ikke blir tre beskjeder. Samme moenster
       som i assets/nf-kalkulator.js. */
    function visFeil(tekst) {
      var f = el('feil');
      if (!f) return;
      f.textContent = tekst || '';
      f.hidden = !tekst;
    }

    var ansaTimer = null;
    function ansa(tekst) {
      var a2 = el('ansa');
      if (!a2) return;
      if (ansaTimer) clearTimeout(ansaTimer);
      if (!tekst) { a2.textContent = ''; return; }
      ansaTimer = setTimeout(function () { a2.textContent = tekst; }, 500);
    }

    velger.addEventListener('change', regn);
    areal.addEventListener('input', regn);
    areal.addEventListener('blur', function () {
      var t = String(areal.value || '').trim();
      if (t !== '' && isNaN(lesAreal(t))) visFeil('Skriv arealet i m², for eksempel 23 eller 23,5.');
    });
    regn();
  }

  function boot(rot) {
    var noder = (rot || document).querySelectorAll('[data-nf-serie="rot"]');
    Array.prototype.forEach.call(noder, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* Theme-editoren bytter ut seksjonens DOM ved re-render; init på nytt. */
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
